import React from 'react';
import cx from 'classnames';
import Popup from './PopupItem';
import { types, getType } from '../../../../const/types.task';
import { isAction, isCondition } from '../../../../functions/forms';

import Chip from '@material-ui/core/Chip';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import FilterList from '@material-ui/icons/FilterList';
import Contidition from '@material-ui/icons/Code';
import Action from '@material-ui/icons/SubdirectoryArrowRight';

import { DotsIcon } from '../../../../images/icons/WrapSvg';

import {
    DragIcon,
    ListIcon,
    TypeTabIcon,
    TypeBooleanIcon,
    TypeActionIcon,
    TypeCalendarIcon,
    TypeCameraIcon,
    TypeCheckBoxIcon,
    TypeDropdownIcon,
    TypeFileIcon,
    TypeMultiCheckIcon,
    TypeNumberRealIcon,
    TypeSignIcon,
    TypeTextFixedIcon,
    TypeTextIcon,
    TypeTempIcon,
    TypeTempAutoIcon,
    TypeTimeIcon,
    TypeVenueIcon,
    TypeVideoIcon,
    DateTimeIcon
} from '../../../../images/icons/WrapSvg';

const getIcon = (type, style, color) => {
    switch (getType(type, style)) {
        case types.section:
            return <ListIcon className={color} />;
        case types.action:
            return <TypeActionIcon className={color} />;
        case types.date:
            return <TypeCalendarIcon className={color} />;
        case types.time:
            return <TypeTimeIcon className={color} />;
        case types.datetime:
            return <DateTimeIcon className={color} />;
        case types.file:
            return <TypeFileIcon className={color} />;
        case types.photo:
            return <TypeCameraIcon className={color} />;
        case types.video:
            return <TypeVideoIcon className={color} />;
        case types.options:
            return <TypeDropdownIcon className={color} />;
        case types.multioption:
            return <TypeMultiCheckIcon className={color} />;
        case types.number:
        case types.real:
            return <TypeNumberRealIcon className={color} />;
        case types.text:
            return <TypeTextIcon className={color} />;
        case types.textfixed:
            return <TypeTextFixedIcon className={color} />;
        case types.signature:
            return <TypeSignIcon className={color} />;
        case types.checks:
            return <TypeCheckBoxIcon className={color} />;
        case types.local:
            return <TypeVenueIcon className={color} />;
        case types.boolean:
            return <TypeBooleanIcon className={color} />;
        case types.tab:
            return <TypeTabIcon className={color} />;
        case types.temp:
            return <TypeTempIcon className={color} />;
        case types.auto:
            return <TypeTempAutoIcon className={color} />;
        default:
            return <div />;
    }
};

class Field extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: undefined,
            toolbar: false,
            rule: undefined
        };
    }

    static getDerivedStateFromProps(props, state) {
        const { rule, rules, id, selectedRule, selectedField, selectedType } = props;
        if (rule !== state.rule || rules !== state.rules || id !== state.id || selectedField) {
            state.id = id;
            state.rule = rule;
            state.rules = rules;
            state.selectedRule = selectedRule;
            state.selectedField = selectedField;
            state.selectedType = selectedType;
            state.condition = rule && rule.condicion && isCondition(rule, id);
            state.action = rule && rule.accion && isAction(rule, id);
            state.inSelecteActiondRule = selectedRule && (isAction(selectedRule, id));
            state.inSelecteConditiondRule = selectedRule && (isCondition(selectedRule, id));
            state.conditionRules = !rule && rules && rules.reduce((result, item) => { result = result || isCondition(item, id); return result }, false);
            state.actionRules = !rule && rules && rules.reduce((result, item) => { result = result || isAction(item, id); return result }, false)
            return state;
        }
        return null;
    }

    handleClick = (event) => {
        this.setState({
            toolbar: !this.state.toolbar,
        });
    };

    handleHide = (id, hide, canHide) => (event) => {
        if (canHide) this.props.onHide(id, hide);
    };

    handleOpen = (event) => {
        this.setState({ open: event.currentTarget });
    };

    handlePopup = (task) => (event) => {
        const { element } = this.props;
        switch (task) {
            case 'delete':
                this.props.onDelete(element);
                break;
            case 'see':
                this.props.onSee(element);
                break;
            case 'duplicity':
                this.props.onDuplicate(element);
                break;
            case 'edit':
                this.props.onEdit(element);
                this.setState({ open: null, editProcess: true });
                break;
            default:
                break;
        }
        this.setState({ open: null });
    };

    render() {
        const {
            name,
            type,
            style,
            id,
            hide,
            programation,
            isDragging,
            modified,
            element,
            edit_rule,
            typeId,
            rule,
            selectedRule,
            selectedField,
            selectedType,
            sts
        } = this.props;
        const { open,
            condition,
            action,
            actionRules,
            conditionRules,
            inSelecteActiondRule,
            inSelecteConditiondRule
        } = this.state;
        const active = (!rule && !selectedRule && !selectedField) || selectedField === id || condition || action || inSelecteActiondRule || inSelecteConditiondRule;
        const background = isDragging
            ? 'bg_bluish '
            : modified
                ? 'bg_golden_yellow '
                : hide
                    ? 'bg_cloudy_blue '
                    : active
                        ? selectedField === id
                            ? selectedType === 'condicion'
                                ? 'bg_bluish_25'
                                : 'bg_lipstickligth'
                            : 'bg_white '
                        : 'bg_black_6';
        const canHide = type === types.tab || type === types.section;
        const color = programation && programation.length > 0
            ? 'c_lipstick'
            : active ? "c_bluish" : "c_bluish_25";

        return (
            <div id={id} className={cx('flex_full_column boxBorderForm ', background, type)}>
                <div className={'flex_auto_row align_center padding_top_12 padding_bottom_12'}>
                    <div
                        className={'display_flex heigth100 width64px center hand '}
                        onClick={this.handleHide(id, !hide, canHide)}
                    >
                        {canHide && hide && (
                            <ExpandMore
                                id={id}
                                className={cx(
                                    color,
                                    type,
                                )}
                            />
                        )}
                        {canHide && !hide && (
                            <ExpandLess
                                id={id}
                                className={cx(
                                    color,
                                    type,
                                )}
                            />
                        )}
                        {!canHide && programation && programation.length > 0 ? (
                            <FilterList id={id} className={cx('c_lipstick', type)} />
                        ) : (
                                !canHide && <DragIcon id={id} className={cx(color, type)} />
                            )}
                    </div>
                    <div id={id} className={'flex_full_column'}>
                        <div id={id} className={'flex_full_row align_center'}>
                            <div className={'display_flex heigth100 width64px center '}>
                                {getIcon(type, style, active ? "c_bluish" : "c_bluish_25")}
                            </div>
                            <div
                                id={id}
                                className={
                                    'flex_full_row barlow_regular_textwrap text_align_left text_wrap hand upper '
                                    + (active ? 'c_slate' : 'c_disabled')
                                }
                                dangerouslySetInnerHTML={{ __html: name }}
                            />
                            <div className={'display_flex heigth100 width64px center'}></div>
                        </div>
                    </div>
                    {sts &&
                        <div className="flex_auto_row nowrap align_center">
                            <img 
                                alt="sts"
                                width="24"
                                src="data:image/png;base64,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"
                            />
                        </div>
                    }
                    {!edit_rule && conditionRules && (
                        <div className={"center barlow_regular_subtitle hand " + ((!selectedRule && !selectedField) || selectedField === id || inSelecteConditiondRule ? "dotBlue" : "dotGray")}
                            onClick={(event) => this.props.onSelectedField(id, 'condicion')}>
                            C
                        </div>
                    )}
                    {!edit_rule && actionRules && (
                        <div className={"center barlow_regular_subtitle hand " + ((!selectedRule && !selectedField) || selectedField === id || inSelecteActiondRule ? "dotRed" : "dotGray")}
                            onClick={(event) => this.props.onSelectedField(id, 'accion')}>
                            R
                        </div>
                    )}
                    {!edit_rule && (
                        <div
                            className={cx(
                                'display_flex heigth100 width64px elements_center text_align_center align_center ',
                            )}
                            onClick={this.handleOpen}
                        >
                            <DotsIcon className="c_bluish hand" />
                        </div>
                    )}
                    {edit_rule && (
                        <React.Fragment>
                            {(!canHide && !action) && (
                                <Contidition
                                    className={"c_bluish hand margin_right_12"}
                                    onClick={(event) => this.props.onAddContion(element)}
                                />
                            )}
                            {(typeId &&
                                typeId === "1" &&
                                !condition &&
                                !action &&
                                type !== types.section) &&
                                <Action
                                    className="c_slate_grey hand margin_right_12"
                                    onClick={(event) => this.props.onAddAction(element)}
                                />
                            }

                        </React.Fragment>
                    )}
                </div>
                <div id={id} className={'flex_auto_row padding_left_64'}>
                    {condition &&
                        <Chip color="primary" label={this.props.intl.formatMessage({ id: 'checks_condition' })} className="margin_bottom_12 margin_right_12" />
                    }
                    {action &&
                        <Chip color="secondary" label={this.props.intl.formatMessage({ id: 'checks_result' })} className="margin_bottom_12" />
                    }
                </div>
                {open && <Popup open={open} duplicateOnly={conditionRules || actionRules} onClick={this.handlePopup} />}
            </div>
        );
    }
}

export default Field;



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/Field.js